// Live Available Shifts - GetLiveAvailableShiftsWithPagination
export const FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST = 'FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST';
export const FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS = 'FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS';
export const FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE = 'FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE';

// Modal-only "Schedule View" table (RequestForScheduleModal) — kept on its own
// action types/state so its fetches never clobber the main table's redux data.
export const FETCH_MODAL_SCHEDULE_REQUEST = 'FETCH_MODAL_SCHEDULE_REQUEST';
export const FETCH_MODAL_SCHEDULE_SUCCESS = 'FETCH_MODAL_SCHEDULE_SUCCESS';
export const FETCH_MODAL_SCHEDULE_FAILURE = 'FETCH_MODAL_SCHEDULE_FAILURE';

export const FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST = 'FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST';
export const FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS = 'FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS';
export const FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE = 'FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE';
export const FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_REQUEST = 'FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_REQUEST';
export const FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_SUCCESS = 'FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_SUCCESS';
export const FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_FAILURE = 'FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_FAILURE';

// Legend Table Data
export const FETCH_LEGEND_TABLE_DATA_REQUEST = 'FETCH_LEGEND_TABLE_DATA_REQUEST';
export const FETCH_LEGEND_TABLE_DATA_SUCCESS = 'FETCH_LEGEND_TABLE_DATA_SUCCESS';
export const FETCH_LEGEND_TABLE_DATA_FAILURE = 'FETCH_LEGEND_TABLE_DATA_FAILURE';

// Priority Grouping Legend
export const FETCH_PRIORITY_GROUPING_LEGEND_REQUEST = 'FETCH_PRIORITY_GROUPING_LEGEND_REQUEST';
export const FETCH_PRIORITY_GROUPING_LEGEND_SUCCESS = 'FETCH_PRIORITY_GROUPING_LEGEND_SUCCESS';
export const FETCH_PRIORITY_GROUPING_LEGEND_FAILURE = 'FETCH_PRIORITY_GROUPING_LEGEND_FAILURE';

// Provider Request dropdown and save
export const FETCH_RAD_REQUEST_TYPE_REQUEST = 'FETCH_RAD_REQUEST_TYPE_REQUEST';
export const FETCH_RAD_REQUEST_TYPE_SUCCESS = 'FETCH_RAD_REQUEST_TYPE_SUCCESS';
export const FETCH_RAD_REQUEST_TYPE_FAILURE = 'FETCH_RAD_REQUEST_TYPE_FAILURE';

export const SAVE_RAD_REQUEST_REQUEST = 'SAVE_RAD_REQUEST_REQUEST';
export const SAVE_RAD_REQUEST_SUCCESS = 'SAVE_RAD_REQUEST_SUCCESS';
export const SAVE_RAD_REQUEST_FAILURE = 'SAVE_RAD_REQUEST_FAILURE';

// Schedule Recurrence dropdown
export const FETCH_SCHEDULE_RECURRENCE_REQUEST = 'FETCH_SCHEDULE_RECURRENCE_REQUEST';
export const FETCH_SCHEDULE_RECURRENCE_SUCCESS = 'FETCH_SCHEDULE_RECURRENCE_SUCCESS';
export const FETCH_SCHEDULE_RECURRENCE_FAILURE = 'FETCH_SCHEDULE_RECURRENCE_FAILURE';

export const SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST = 'SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST';
export const SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS = 'SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS';
export const SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE = 'SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE';
